"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LinkTheaterForm = require("./LinkTheaterForm");
Object.keys(_LinkTheaterForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LinkTheaterForm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LinkTheaterForm[key];
    }
  });
});